import { Route, Routes } from 'react-router-dom'
import { useEffect } from 'react'
import ImmersiveLayout from '@/components/ImmersiveLayout'
import Accueil from '@/pages/Accueil'
import Comprendre from '@/pages/Comprendre'
import Experimenter from '@/pages/Experimenter'
import Transformation from '@/pages/Transformation'
import Alignement from '@/pages/Alignement'
import Accompagnements from '@/pages/Accompagnements'
import Contact from '@/pages/Contact'
import Sanctuaire from '@/pages/Sanctuaire'
import AdminEditor from '@/pages/AdminEditor'
import AdminAccompagnements from '@/pages/AdminAccompagnements'
import { preloadSiteContent } from '@/hooks/useSiteContent'

function App() {
  useEffect(() => {
    preloadSiteContent()
  }, [])

  return (
    <ImmersiveLayout>
      <Routes>
        <Route path="/" element={<Accueil />} />
        <Route path="/comprendre" element={<Comprendre />} />
        <Route path="/experimenter" element={<Experimenter />} />
        <Route path="/transformation" element={<Transformation />} />
        <Route path="/alignement" element={<Alignement />} />
        <Route path="/accompagnements" element={<Accompagnements />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/sanctuaire" element={<Sanctuaire />} />
        <Route path="/admin" element={<AdminEditor />} />
        <Route path="/admin/accompagnements" element={<AdminAccompagnements />} />
        <Route path="*" element={<Accueil />} />
      </Routes>
    </ImmersiveLayout>
  )
}

export default App
